"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHigherOperatorOrder = void 0;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence
var operators = new Map();
operators.set('!', 16);
operators.set('~', 16);
operators.set('+', 16);
operators.set('-', 16);
operators.set('++', 16);
operators.set('--', 16);
operators.set('**', 15);
operators.set('*', 14);
operators.set('/', 14);
operators.set('%', 14);
operators.set('+', 13);
operators.set('-', 13);
operators.set('<<', 12);
operators.set('>>', 12);
operators.set('>>>', 12);
operators.set('<', 11);
operators.set('<=', 11);
operators.set('>', 11);
operators.set('>=', 11);
operators.set('&', 9);
operators.set('^', 8);
operators.set('|', 7);
operators.set('&&', 6);
operators.set('||', 5);
function isHigherOperatorOrder(op1, op2) {
    return operators.get(op1) > operators.get(op2);
}
exports.isHigherOperatorOrder = isHigherOperatorOrder;
//# sourceMappingURL=isHigherBinaryOperatorOrder.js.map